import * as S from './styles';

type MessageTypePaymentProps = {
  icon: React.ReactElement;
  text: string;
  content?: string;
  subtitle?: string;
  colorText?: string;
  position?: 'right' | 'left'; // Prop para definir a posição do tooltip
};

export const MessageTypePayment = ({
  content,
  icon,
  text,
  subtitle,
  colorText,
  position = 'right', // Valor padrão para posição à direita
}: MessageTypePaymentProps) => {
  return (
    <S.Wrapper
      role={content ? 'tooltip' : undefined}
      aria-label={content || ''}
      position={position} // Passa a prop `position` para definir a posição do tooltip
    >
      <div>
        {icon}
        <p style={{ color: colorText }}>{text}</p>
      </div>
      <span style={{ color: colorText }}>{subtitle}</span>
    </S.Wrapper>
  );
};
